import { call, all, takeEvery, put } from 'redux-saga/effects';

import { loadingTransactionsSummary, TransactionActionTypes, changeTransactionDetails, changeTransactionsLatest, changeTransactionsSummary, loadingTransactionDetails } from 'store/reducers/transaction.reducer';
import { getTransactionDetails, getTransactionsLatest, getTransactionsSummary } from 'utils/web-api';
import Notification from 'utils/notifications';
import { loadingStart, loadingStop } from 'store/reducers/loading.reducer';

function* transactionDetails({ payload }) {
  try {
    yield put(loadingTransactionDetails(true));

    const response = yield call(getTransactionDetails, payload);
  yield put(changeTransactionDetails(response));
  } catch (error) {
    Notification('error', 'Ocorreu um erro inesperado, tente novamente.');
  } finally {
    yield put(loadingTransactionDetails(false));
  }
}

function* transactionsLatest({ payload }) {
  try {
    yield put(loadingStart())
    const response = yield call(getTransactionsLatest, payload);
    yield put(changeTransactionsLatest(response));
  } catch (error) {
   Notification('error', 'Erro ao carregar os últimos 10 pagamentos.');
  } finally {
    yield put(loadingStop());
  }
}

function* transactionsSummary({payload}) {
  try {
    yield put(loadingTransactionsSummary(true))
    const response = yield call(getTransactionsSummary, payload);
    yield put(changeTransactionsSummary(response));
  } catch (error) {
   Notification('error', 'Erro ao carregar as transações por método de pagamento.');
  } finally {
    yield put(loadingTransactionsSummary(false));
  }
}

export default function* MySaga() {
  yield all([
    yield takeEvery(TransactionActionTypes.ASYNC_TRANSACTION_DETAILS, transactionDetails),
    yield takeEvery(TransactionActionTypes.ASYNC_TRANSACTIONS_LATEST, transactionsLatest),
    yield takeEvery(TransactionActionTypes.ASYNC_TRANSACTIONS_SUMMARY, transactionsSummary)

  ]);
}
